import registerComponents from "../register-components";
import UiDashboard from "../bundles/UiDashboard/components/UiDashboard";
import AppNavigationSidebar from "../ui-dashboard/src/organisms/AppNavigation/AppNavigationSidebar";
import PublicKioskPage from "../ui-dashboard/src/pages/PublicKioskPage";
import RequestNewPaymentMethodRoot from "../ui-dashboard/src/organisms/Billing/RequestNewPaymentMethodRoot";
import SentryInit from "../sentry-react-init";
import InAppAnnouncementRoot from "../ui-dashboard/src/organisms/Announcements/InAppAnnouncementRoot";
import PageWiseBanner from "../ui-dashboard/src/pages/PageWiseBanner";
import GlobalLayout from "../ui-dashboard/src/templates/GlobalLayout";
import LearnerPdfViewer from "../ui-dashboard/src/organisms/learner-portal/DocumentPolicies/LearnerPdfViewer";
import { initializeNewRelicBrowser } from "../newrelic-browser-init";

SentryInit();
initializeNewRelicBrowser();

// This is how react_on_rails can see the component in the browser.
registerComponents({
  UiDashboard
});

registerComponents({
  AppNavigationSidebar
});

registerComponents({
  PublicKioskPage,
});

registerComponents({
  RequestNewPaymentMethodRoot
});

registerComponents({
  InAppAnnouncementRoot,
});

registerComponents({
  PageWiseBanner,
});

registerComponents({
  GlobalLayout,
});

registerComponents({
  LearnerPdfViewer,
});
